import { useEffect, useState, useContext } from 'react';

import { useAdditionalFetchDataHelpersPluginCallback } from '../../AdditionalFetchDataHelpersPlugin';
import { Box } from '../../../../../Box';
import { Icon } from '../../../../../Icon';
import { Typography } from '../../../../../Typography';
import { Link } from '../../../../../Link';
import { bytesToSize } from '../../../../../format';
import { WysiwygContext } from '../../../context';
import { sanitizeUrl } from '../../../utils';
import { useLogger } from '../../../../../services/hooks';

interface FileProps {
  name: string;
  size: number;
  id: string;
  editable: boolean;
}

export const File = ({ name, size, id, editable }: FileProps) => {
  const contextHelpers = useAdditionalFetchDataHelpersPluginCallback();
  const logger = useLogger();

  const { apiUrl } = useContext(WysiwygContext);

  const [src, setSrc] = useState('');

  useEffect(() => {
    if (src) return;

    if (contextHelpers?.getAttachmentUrl) {
      if (contextHelpers.getAttachmentUrl) {
        const fetchAttachmentUrl = async () => {
          await contextHelpers
            .getAttachmentUrl(id)
            .then((res) => {
              setSrc(() => res);

              return res;
            })
            .catch((err) => {
              logger.error(err, {
                tags: {
                  vkdoc_error_type: 'wysiwyg input file node',
                },
              });
            });
        };

        fetchAttachmentUrl();
      }
    }
  }, [apiUrl, src, id, contextHelpers, logger]);

  return (
    <Box display="flex" alignItems="center" gap="12" id={id}>
      <div data-url="" />
      <Box
        p="12"
        width={44}
        height={44}
        bgcolor="bg.greyscale.primary"
        radius="s"
        color="stroke.tertirary"
      >
        <Icon name="attach" size="20" color="stroke.tertirary" />
      </Box>
      <Box display="flex" flexDirection="column" gap="2">
        <Typography variant="subtitle2" color="text.light.primary">
          {name}
        </Typography>
        <Box display="flex" alignItems="center" gap="4">
          <Typography variant="caption" color="text.dark.secondary">
            {bytesToSize(size)}
          </Typography>

          {!editable && (
            <>
              <Icon
                name="circle_small_filled"
                size="16"
                color="text.light.tertirary"
              />

              <Link
                href={sanitizeUrl(src)}
                size="extraSmall"
                variant="primary"
                stroke={false}
                target="_blank"
              >
                Скачать файл
              </Link>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};
